import { useQueryClient } from '@tanstack/react-query';
import { IDashboardJobsInfo } from '../dashboardJobsTypes';

export const useDashboardJobInfo = () => {
  const queryClient = useQueryClient();
  const data = queryClient.getQueryData(['dashboard-jobs-info']);

  return data as IDashboardJobsInfo | undefined;
};